module.exports = __webpack_public_path__ + "img/logo_white.97e6510d.svg";